<template>
  <div class="w-100">
    <div class=" p-list-representation-wrapper align-items-start">
      <Loader class="w-100" :loading="loading">
        <div  class="w-100p-list-representation-content row mr-auto ml-auto align-items-start">
            <div class="w-100" >
              <appHeader></appHeader>
            </div>

            <div class=" row p-list-representation-data w-100">
              <contentList
                @submitData="submitData"
                :form-data="formData"

              ></contentList>
            </div>

        </div>
      </Loader>

    </div>


  </div>
</template>

<script>
import contentList from '../components/mapLocation/contentList';
import appHeader from '../components/includes/AppHeader';



export default {
  name: "mapLocation",
  components: {
    contentList,
    appHeader,
  },

  props: {

  },

  data() {
    return {
      loading       : false,
      formData      : {

      },
    }
  },

  watch: {
    formData(data){
      const location = data.position.coordinates;
      const lng      = location[0];
      const lat      = location[1];

      data.lat       = lat;
      data.lng       = lng;
    }
  },

  created() {

  },

  mounted() {
    const  singleData = JSON.parse(localStorage.getItem('hallSingle'));
    this.formData     = singleData;
  },


  methods: {
    paganationChangePage(data){
      console.log(data,'paganationChangePage');
    },

    submitTransaction(){

    },

    editRepresentation(){

    },

    modalShowEntryPay(){
      this.statusShowModalEntryPay = true;
    },

    closeModalEntry(status){
      if (!status) {
        this.statusShowModalEntryPay = false;
      }
    },

    submitData(data){
      this.formData.lat = data.lat;
      this.formData.lng = data.lng;

      
    }

  }


}
</script>
